export default "__VITE_ASSET__Y73cl9MdOyIk4yncO3OBiw__"